import Handler from "../Handler";
class DealICMFailHandler extends Handler {
    // DealICMFail#{"tourneyId"}
    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processDealICMFailProtocol(receivedData);
    }
}
export default DealICMFailHandler;